<div class="busy-indicator-overlay-circular">
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 20 20"
         class="busy-indicator-overlay-circular-container"
         style="width: 60px; height: 60px; transform-origin: 30px 30px 30px;">
        <path fill="none"
              stroke-width="2"
              class="busy-indicator-overlay-circular-path"
              stroke-linecap="square"
              d="M10,1A9,9 0 1 1 1,10"
              transform="rotate(-270 10 10)"></path>
    </svg>    
</div>
<div class="busy-loading-content-circular">{{BusyMessage}}</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/busy-indicator/busy-indicator-overlay-circular/busy-indicator-overlay-circular.html